<template>
  <DefaultLayout name="DefaultLayout">
    <vue-headful :title="getPageTitle('Dashboard')" />
    <HeroBar :class="$style.heroBar">
      Dashboard
      <router-link
        slot="right"
        to="/projects/create"
        class="button is-large is-rounded is-primary"
      >
        Create Project
      </router-link>
    </HeroBar>
    <section class="section project-list-screen">
      <DashboardProjectList></DashboardProjectList>
      <DashboardRecentEventLogs></DashboardRecentEventLogs>
      <DashboardDataHistory></DashboardDataHistory>
    </section>
  </DefaultLayout>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { useAuthState } from '@/utils/store.util';
import DefaultLayout from '../../layouts/DefaultLayout.vue';
import HeroBar from '@/components/base/HeroBar.vue';
import DashboardProjectList from '@/views/Dashboard/components/DashboardProjectList.vue';
import DashboardDataHistory from '@/views/Dashboard/components/DashboardDataHistory.vue';
import DashboardRecentEventLogs from '@/views/Dashboard/components/DashboardRecentEventLogs.vue';

@Component({
  components: {
    DashboardRecentEventLogs,
    DashboardDataHistory,
    DashboardProjectList,
    DefaultLayout,
    HeroBar,
  },
})
export default class DashboardPage extends Vue {
  get isLoggedIn(): boolean {
    return useAuthState.call(this).isLoggedIn;
  }
}
</script>
<style lang="scss" module>
.noDataMessageContainer {
  text-align: center;
  vertical-align: middle;
  height: 100%;
}
.noDataMessage {
  line-height: 30;
  color: #9f9f9f;
  font-size: 18px;
}
.heroBar {
  margin-right: 16px;
  margin-left: 16px;
}
</style>
